// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--jqrym";
export var wrapper = "styles-module--wrapper--FdvZU";
export var heroContent = "styles-module--heroContent--Oh4QD";
export var heroArrowWrapper = "styles-module--heroArrowWrapper--iFzGI";
export var heroSubheading = "styles-module--heroSubheading--SEf9P";
export var heroHeader = "styles-module--heroHeader--Hzrcs";
export var btn = "styles-module--btn--78WqX";